import React from 'react';
import PropTypes from 'prop-types';

const InputGroup = ({ symbol, text, id, label, onChange, value, reverse = false }) => {
    return (
        <div className={`inputGroup -tagged ${reverse ? '-reverse' : ''}`}>
            <input
                id={id}
                aria-label={label}
                title={label}
                type="text"
                name={id}
                defaultValue={value}
                className="inputGroup__input"
            />
            <span className="inputGroup__tag">
                {!!symbol && (
                    <svg className="symbol inputGroup__icon">
                        <use xlinkHref={`#${symbol}`} />
                    </svg>
                )}
                {text}
            </span>
        </div>
    );
};

InputGroup.propTypes = {
    symbol: PropTypes.string,
    text: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    reverse: PropTypes.bool,
};

export default InputGroup;
